/**
 * Split Scene Edit load — shell first, then paginated lean segments.
 * Avoids GET /narration/projects/{id} (full docs + recovery) on first paint.
 */

import api from '@/lib/api';
import { narrationSegmentToScene } from '@/lib/sceneGridNarrationAdapter';

export const SCENE_EDIT_PAGE_SIZE = 8;

export async function fetchNarrationSceneEditShell(projectId) {
  const { data } = await api.get(`/narration/projects/${projectId}/edit-shell`, {
    params: { _fresh: Date.now() },
  });
  return data;
}

/**
 * @returns {Promise<{ segments: object[], total: number, limit: number, offset: number, has_more: boolean }>}
 */
export async function fetchNarrationSceneEditScenesPage(projectId, {
  limit = SCENE_EDIT_PAGE_SIZE,
  offset = 0,
} = {}) {
  const { data } = await api.get(`/narration/projects/${projectId}/edit-scenes`, {
    params: {
      limit,
      offset,
      _fresh: Date.now(),
    },
  });
  const totalRaw = data?.total;
  return {
    segments: Array.isArray(data?.segments) ? data.segments : [],
    total: totalRaw == null || totalRaw === '' ? null : Number(totalRaw) || 0,
    limit: Number(data?.limit) || limit,
    offset: Number(data?.offset) || offset,
    has_more: Boolean(data?.has_more),
  };
}

export function mapEditSegmentsToScenes(segments, project) {
  return (Array.isArray(segments) ? segments : []).map((seg) => narrationSegmentToScene(seg, project));
}

/** Merge a page of scenes by id (keeps order by segment_number). */
export function mergeSceneEditPages(prevScenes, nextScenes) {
  const byId = new Map();
  (prevScenes || []).forEach((s) => {
    if (s?.id) byId.set(String(s.id), s);
  });
  (nextScenes || []).forEach((s) => {
    if (s?.id) byId.set(String(s.id), s);
  });
  return Array.from(byId.values()).sort(
    (a, b) => (Number(a.segment_number || a.scene_number) || 0)
      - (Number(b.segment_number || b.scene_number) || 0),
  );
}
